import React from 'react';
import btoa from 'btoa';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import isBoolean from 'lodash/isBoolean';

export const Helpers = {
  isMobile: function (iPhoneOnly, excludeTablet, customUserAgentData) {
    var agentStyles;
    if (customUserAgentData || global.navigator) {
      if (iPhoneOnly) {
        agentStyles = /iPhone/i.test(customUserAgentData || global.navigator.userAgent);
      } else if (excludeTablet) {
        agentStyles = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(customUserAgentData || navigator.userAgent);
      } else {
        agentStyles = /Android.+Mobile|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(customUserAgentData || global.navigator.userAgent);
      }
    }
    var isMobile = agentStyles;
    return isMobile;
  },
  isFirefox: function () {
    var isFirefox = /Firefox/i.test(navigator.userAgent);
    return isFirefox;
  },
  setCookies: function (ssoResponse) {
    var rightNow = new Date();
    var timeNow = rightNow.getTime();
    var stringTime = rightNow.toDateString();
    var correctAccessToken = btoa(ssoResponse.access_token);
    window.PSSessions.set.accessToken(correctAccessToken, timeNow, ssoResponse.expires_in);
    window.PSSessions.set.thisCookie('PSRefresh', ssoResponse.refresh_token);
    window.PSSessions.set.state(stringTime);
  },
  fixAffix: function (el) {
    // fix affix issues in Safari
    if (-1 !== navigator.userAgent.indexOf('Safari') && -1 === navigator.userAgent.indexOf('Chrome')) {
      const affixEl = $(el);
      const setAffix = () => {
        affixEl.css('left', `${affixEl.offset().left}px`);
      };

      /* Before the element becomes affixed, add left CSS that is equal to the distance of the element from the left of the screen */
      affixEl.on('affix.bs.affix', () => setAffix());

      /* On resize of window, un-affix affixed widget to measure where it should be located, set the left CSS accordingly, re-affix it */
      $(window).resize(() => {
        if (affixEl.hasClass('affix')) {
          affixEl.removeClass('affix');
          setAffix();
          affixEl.addClass('affix');
        }
      });
    }
  },
  parseDate: function (date) {
    const year = (date).format('YYYY');
    const month = (date).format('MM');
    const day = (date).format('DD');
    return {
      y: parseInt(year, 10),
      m: parseInt(month, 10),
      d: parseInt(day, 10)
    };
  },
  parseHash: function (hash) {
    var sliceHash = hash.slice(1);
    var whatsInHash = sliceHash.split('&');
    var hashObj = {};
    whatsInHash.forEach(function (item) {
      var splitHash = item.split('=');
      hashObj[splitHash[0]] = splitHash[1];
    });
    return hashObj;
  },
  pickColor: function (color) {
    switch (color) {
    case 'blue':
      return '#2993e8';
    case 'orange':
      return '#e88129';
    case 'green':
      return '#68b252';
    case 'red':
      return '#e82933';
    case 'black':
      return '#4b4b4b';
    default:
      return '#4b4b4b';
    }
  },
  isExists: function (val) {
    if (isNumber(val)) {
      return true;
    }
    if (isBoolean(val)) {
      return val;
    }
    return !isEmpty(val);
  },
  renderStarsArray: function (renderStars) {
    const starsInt = renderStars ? parseFloat((renderStars).toFixed(1)) : 0;
    let stars = [];
    if (0 === starsInt) {
      stars = [];
    } else {
      var halfStar = starsInt - parseInt(starsInt, 10);
      for (var i = 1; i <= starsInt; i++) {
        stars.push('icon-full-star');
      }
      if (0 !== starsInt % 1) {
        if ((0.25 < halfStar) && (0.75 > halfStar)) {
          stars.push('icon-half-star');
        } else if (0.25 > halfStar) {
          stars.push('icon-empty-star');
        } else {
          stars.push('icon-full-star');
        }
      }
      var emptyStars = 5 - starsInt;
      for (var j = 1; j <= emptyStars; j++) {
        stars.push('icon-empty-star');
      }
    }
    return stars;
  },
  convertScheduleToMoment: function (schedule) {
    const s = schedule[0].start.date;
    const { d, m, y } = s;

    // moment renders base 0 months, our API is 1-12
    return moment().set({ month: m - 1, date: d, year: y });
  },
  isPowerHost: function (profile) {
    const hasPowerHostAttr = get(profile, 'host_state');
    const isPowerHost = !!(hasPowerHostAttr && 'POWER_HOST' === profile.host_state);
    return isPowerHost;
  },
  removeByKey: function (myObj, deleteKey) {
    return Object.keys(myObj)
      .filter(key => key !== deleteKey)
      .reduce((result, current) => {
        return {
          ...result,
          current: myObj[current]
        };
      }, {});
  },
  userHasNoAccount: function (grantsRes) {
    return !grantsRes.facebook && !grantsRes.email && !grantsRes.google && !grantsRes.apple;
  },
  isFacebookUserLoggedOutError: function (err) {
    return 190 === err.code && 467 === err.error_subcode;
  },
  somethingWentWrongError: function () {
    return <FormattedMessage id="shared_components.page_login.something_wrong" defaultMessage="Something went wrong, please try again. If the problem persists please refresh." />;
  },
  retryLogin: function (retryCount, maxRetries, setError, callback) {
    if (retryCount < maxRetries) {
      callback();
    } else {
      setError();
    }
  },
  handleFacebookError: function (fetchRes, retryCount, maxRetries, facebookLogin, setError) {
    if (fetchRes.error && this.isFacebookUserLoggedOutError(fetchRes.error)) {
      return this.retryLogin(retryCount, maxRetries, setError, () => {
        FB.getLoginStatus((response) => {
          if (response.status === 'connected') {
            FB.logout(() => facebookLogin());
          } else {
            facebookLogin();
          }
        });
      });
    } else {
      setError();
    }
  }
};
